export default "__VITE_ASSET__CjE1FZFo__"